import { render, staticRenderFns } from "./PublicI.vue?vue&type=template&id=2ff889f3"
import script from "./PublicI.vue?vue&type=script&lang=js"
export * from "./PublicI.vue?vue&type=script&lang=js"
import style0 from "./PublicI.vue?vue&type=style&index=0&id=2ff889f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports